import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import { InfoTooltip } from '@dashboard/components/Tooltip';
import { Label as ShadcnLabel } from '@dashboard/components/ui/label';

import LabelDescription from '../LabelDescription';

const propTypes = {
  htmlFor: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.node]).isRequired,
  className: PropTypes.string,
};

const defaultProps = {
  htmlFor: '',
  className: '',
};

// Hidden from assistive tech so the label's accessible name stays unchanged; the
// input's own `required` carries the state.
export const RequiredMarker = () => (
  <span aria-hidden="true" className="ml-0.5">
    *
  </span>
);

const Label = ({
  className,
  children,
  htmlFor,
  isInline,
  disabled,
  optional,
  required,
  tooltip,
  tags = [],
  description,
  ...props
}) => (
  <>
    <ShadcnLabel
      data-disabled={disabled || undefined}
      htmlFor={htmlFor || null}
      className={clsx(
        `block text-gray-900 dark:text-foreground pointer font-medium mb-1 text-sm`,
        className,
        {
          '!mb-0': isInline,
          '!mb-0.5': description,
          'opacity-50': disabled,
        },
      )}
      {...props}
    >
      {children}

      {required && <RequiredMarker />}

      {tooltip && <InfoTooltip>{tooltip}</InfoTooltip>}

      {optional &&
        (tags && tags.length > 0 ? (
          <span className="text-gray-500 dark:text-muted-foreground ml-1 text-sm font-normal">
            (optional, {tags.join(' ,')})
          </span>
        ) : (
          <span className="text-gray-500 dark:text-muted-foreground ml-1 text-sm font-normal">
            (optional)
          </span>
        ))}

      {!optional && tags && tags.length > 0 && (
        <span className="text-gray-500 dark:text-muted-foreground ml-1 text-sm font-normal">
          ({tags.join(' ,')})
        </span>
      )}
    </ShadcnLabel>

    {description && <LabelDescription>{description}</LabelDescription>}
  </>
);

Label.propTypes = propTypes;
Label.defaultProps = defaultProps;

export default Label;
